<div
  class="p-d-flex p-flex-column p-flex-md-row gap-12 p-mt-2"
  [ngClass]="textClass"
>
  <div class="p-label">{{ label }}:</div>
  <div class="p-text-right">{{ text ? text : '--' }}</div>
</div>
